var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { addCommasWithoutDecimal, } from "@domains/utils/numberMethods";
import { OptionChainScreens, } from "../entites/iOptionChain";
import { getLimitedData } from "../utils/getLimitedData";
export var optionChainMapper = function (data, screen) {
    if (screen === OptionChainScreens.CHAIN) {
        var mapperData = {
            future: data.ftObj ? mapFutureAndSpot(data.ftObj) : null,
            spot: data.spObj ? mapFutureAndSpot(data.spObj) : null,
            optionChain: mapChainData(data.opChn),
            exchange: data.exc || "",
            maxPain: data.maxPn || "",
            pcr: data.pcr || "",
            lut: data.lut,
        };
        return mapperData;
    }
    else if (screen === OptionChainScreens.CHART ||
        screen === OptionChainScreens.CHANGE ||
        screen === OptionChainScreens.PAIN) {
        return optionChaingGraphMapper(data, screen);
    }
    else if (screen === OptionChainScreens.ALL) {
        return optionChaingGraphMapper(data);
    }
};
var optionChaingGraphMapper = function (data, screen) {
    var optionGraphEntity = {
        OIChart: {
            calls: [],
            puts: [],
            categoriesData: [],
            pcrValue: "",
            maxPainValue: "",
        },
        OIChange: {
            calls: [],
            puts: [],
            categoriesData: [],
            pcrValue: "",
            maxPainValue: "",
        },
        OptionPain: {
            OptionPains: [],
            pcrValue: "",
            maxPainValue: "",
            categoriesData: [],
        },
        spotPrice: data.spObj.ltp,
    };
    if (screen) {
        if (screen === OptionChainScreens.CHART) {
            optionGraphEntity.OIChart = getOIChartGraph(data);
        }
        else if (screen === OptionChainScreens.CHANGE) {
            optionGraphEntity.OIChange = getOIChangeGraph(data);
        }
        else if (screen === OptionChainScreens.PAIN) {
            optionGraphEntity.OptionPain = getOptionPainGraphs(data);
        }
    }
    else {
        optionGraphEntity = {
            OIChart: getOIChartGraph(data),
            OIChange: getOIChangeGraph(data),
            OptionPain: getOptionPainGraphs(data),
            spotPrice: data.spObj.ltp,
        };
    }
    return optionGraphEntity;
};
var getOIChartGraph = function (data) {
    var OIChart = {
        calls: [],
        puts: [],
        pcr: [],
        categoriesData: getCategoriesData(data, 5),
        pcrValue: data.pcr,
        maxPainValue: data.maxPn,
    };
    sortData(data, 5).map(function (opChain) {
        var _a;
        OIChart.calls.push(parseFloat(opChain.ceQt.opInt));
        OIChart.puts.push(parseFloat(opChain.peQt.opInt));
        (_a = OIChart === null || OIChart === void 0 ? void 0 : OIChart.pcr) === null || _a === void 0 ? void 0 : _a.push(parseFloat(opChain.pcr));
    });
    return OIChart;
};
var getCategoriesData = function (data, limit) {
    var spotPrice = data.spObj.ltp;
    var minArray = [], maxArray = [], finalArray = [];
    data.opChn.map(function (opChn) {
        if (parseFloat(opChn.stkPrc) < parseFloat(spotPrice)) {
            minArray.push(addCommasWithoutDecimal(opChn.stkPrc));
        }
        else {
            maxArray.push(addCommasWithoutDecimal(opChn.stkPrc));
        }
    });
    if (!!limit && limit > 0) {
        finalArray.push.apply(finalArray, __spreadArray(__spreadArray([], __read(getLimitedData(minArray, limit, true)), false), __read(getLimitedData(maxArray, limit)), false));
    }
    else {
        finalArray.push.apply(finalArray, __spreadArray(__spreadArray([], __read(minArray), false), __read(maxArray), false));
    }
    return finalArray;
};
var getOIChangeGraph = function (data) {
    var OIChange = {
        calls: [],
        puts: [],
        categoriesData: getCategoriesData(data, 5),
        pcrValue: data.pcr,
        maxPainValue: data.maxPn,
    };
    sortData(data, 5).map(function (opChain) {
        OIChange.calls.push(-1 * parseFloat(opChain.ceQt.opIntChg));
        OIChange.puts.push(parseFloat(opChain.peQt.opIntChg));
    });
    return OIChange;
};
var getOptionPainGraphs = function (data) {
    var OptionPain = {
        OptionPains: [],
        pcrValue: data.pcr,
        maxPainValue: data.maxPn,
        categoriesData: getCategoriesData(data, 5),
    };
    sortData(data, 5).map(function (opChain) {
        OptionPain.OptionPains.push(parseFloat(opChain.optPn));
    });
    return OptionPain;
};
var sortData = function (data, limit) {
    var spotPrice = data.spObj.ltp;
    var minArray = [], maxArray = [], finalArray = [];
    data.opChn.map(function (opChn) {
        if (parseFloat(opChn.stkPrc) < parseFloat(spotPrice)) {
            minArray.push(opChn);
        }
        else {
            maxArray.push(opChn);
        }
    });
    if (!!limit && limit > 0) {
        finalArray.push.apply(finalArray, __spreadArray(__spreadArray([], __read(getLimitedData(minArray, limit, true)), false), __read(getLimitedData(maxArray, limit)), false));
    }
    else {
        finalArray.push.apply(finalArray, __spreadArray(__spreadArray([], __read(minArray), false), __read(maxArray), false));
    }
    return finalArray;
};
function mapChainData(from) {
    var list = from.map(function (item) {
        return {
            ATM: item.ATM || "",
            optionPain: item.optPn || "",
            pcr: item.pcr || "",
            strikePrice: item.stkPrc || "",
            vtySkw: item.vtySkw || "",
            call: mapCallAndPut(item.ceQt),
            put: mapCallAndPut(item.peQt),
        };
    });
    return list;
}
var mapFutureAndSpot = function (list) {
    return {
        change: list.chg ? list.chg : "",
        changePercentage: list.chgP ? list.chgP : "",
        expiry: list.exp ? list.exp : "",
        expiryFlag: list.expFlg ? list.expFlg : false,
        latestTradingPrice: list.ltp ? list.ltp : "",
        symbol: list.sym ? list.sym : "",
    };
};
var mapCallAndPut = function (list) {
    return {
        askSize: list.akSz ? list.akSz : "",
        askPrice: list.askPr ? list.askPr : "",
        askIvFuture: list.askivfut ? list.askivfut : "",
        askIvSpot: list.askivspt ? list.askivspt : "",
        bidSize: list.bdSz ? list.bdSz : "",
        bidPrice: list.bidPr ? list.bidPr : "",
        bidIvFuture: list.bidivfut ? list.bidivfut : "",
        bidIvSpot: list.bidivspt ? list.bidivspt : "",
        close: list.c ? list.c : "",
        change: list.chg ? list.chg : "",
        changePercentage: list.chgP ? list.chgP : "",
        delta: list.delta ? list.delta : "",
        expiryFlag: list.expFlg ? list.expFlg : false,
        gamma: list.gamma ? list.gamma : "",
        high: list.h ? list.h : "",
        low: list.l ? list.l : "",
        latestTradingPrice: list.ltp ? list.ltp : "",
        ltpIvFuture: list.ltpivfut ? list.ltpivfut : "",
        ltpIvSpot: list.ltpivspt ? list.ltpivspt : "",
        open: list.o ? list.o : "",
        openInterest: list.opInt ? list.opInt : "",
        openInterestChange: list.opIntChg ? list.opIntChg : "",
        openInterestChangePercentage: list.opIntChgP ? list.opIntChgP : "",
        symbol: list.sym ? list.sym : "",
        theta: list.theta ? list.theta : "",
        tradeSymbol: list.trdSym ? list.trdSym : "",
        vega: list.vega ? list.vega : "",
        volume: list.vol ? addCommasWithoutDecimal(list.vol) : "",
        priceOiAnalysis: list.prcOIA ? list.prcOIA : "-",
    };
};
